export var liveStreamingMode;
(function (liveStreamingMode) {
    liveStreamingMode["firstSelected"] = "firstSelected";
    liveStreamingMode["first"] = "first";
    liveStreamingMode["last"] = "last";
})(liveStreamingMode || (liveStreamingMode = {}));
export var defaultItemForSportMode;
(function (defaultItemForSportMode) {
    defaultItemForSportMode["favorites"] = "favorites";
    defaultItemForSportMode["liveStreaming"] = "liveStreaming";
    defaultItemForSportMode["firstSport"] = "sport";
})(defaultItemForSportMode || (defaultItemForSportMode = {}));
export var itemIDs;
(function (itemIDs) {
    itemIDs["favorites"] = "favorites";
    itemIDs["liveStreaming"] = "streaming";
})(itemIDs || (itemIDs = {}));
//# sourceMappingURL=sportConfig.js.map